module.exports = __webpack_public_path__ + "media/images/landing/bg/screens-lafluencers/04-4200cb1529a18f92ffe2bfa7a9042c72.png";